import rg4js from "raygun4js";
import { useEffect } from "react";

import config from "../../config";
import useCurrentUser from "../../hooks/useCurrentUser";

let raygunBooted = false;

export const sendRaygunError = (error: Error) => {
  if (!config.raygunApiKey) return;
  rg4js("send", { error });
};

export default function useRaygun() {
  const { currentUser } = useCurrentUser();
  useEffect(() => {
    if (!config.raygunApiKey) return;

    if (!raygunBooted) {
      rg4js("apiKey", config.raygunApiKey);
      rg4js("enableCrashReporting", true);
      rg4js("setVersion", config.appVersion);
      rg4js("options", {
        ignore3rdPartyErrors: true,
      });
      raygunBooted = true;
    }

    if (raygunBooted) {
      if (currentUser) {
        rg4js("setUser", {
          identifier: currentUser.sub!,
          isAnonymous: false,
        });
        rg4js("withCustomData", { memberNumber: currentUser.memberNumber });
      } else {
        rg4js("setUser", {
          identifier: "",
          isAnonymous: true,
        });
      }
    }
  }, [currentUser]);
}
